import { Pipe, PipeTransform } from '@angular/core';

const STATUS_CODE_340B_MAP = new Map<string, string>([
  ['36', 'Site has no 340B relationships or is non-participating'],
  [
    '37',
    'Site is not owned by a 340B covered entity but acts as a contract pharmacy to one or more covered entities'
  ],
  [
    '38',
    'Site is owned by a participating 340B covered entity but also serves non Eligible Patients'
  ],
  [
    '39',
    'Site is owned by a participating 340B covered entity and serves only Eligible Patients'
  ]
]);

@Pipe({
  name: 'indicator340b',
  standalone: false
})
export class Indicator340bPipe implements PipeTransform {
  transform(statusCode340B?: string | null): string {
    if (!statusCode340B) {
      return '';
    }

    return STATUS_CODE_340B_MAP.get(statusCode340B) ?? '';
  }
}
